$(function() {
  const swiper = new Swiper('.js_awardSwiper', {
    // Optional parameters
    speed: 3000,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 4000,
    },

    // If we need pagination
    pagination: {
      el: '.js_awardSwipe_pagination',
    },
  });

  $('a[href^="#"]').click(function(){
    var headerHight = $(".header-section").outerHeight();
      var speed = 500;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top - headerHight;
      $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
  });

  // $('.scrollEvent').css({'opacity': '0'});
  function scrollEvent() {
    const h = $(window).height();
    const scrollAmount = $(window).scrollTop();
    $('.js_scrollEvent').each(function() {
      const position = $(this).offset().top;
      if (scrollAmount > position - h + 80) {
        $(this).addClass("js_scrollEvent_active");
      }
    });
  }
  $('.js_scrollEvent').css({'opacity': '0'});
  scrollEvent();
  $(function () {
    $(window).scroll(function() {
      scrollEvent();
    });
  });
});
